export const SIDENAVBAR_CONTENT_WRAPPER = 'sidenavbar-content-wrapper';
export const CLAIMSCORE_SETTINGS_NAV_BADGE = 'claimscore-settings-nav-badge';
